<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { onMounted, ref } from 'vue';
import { useRouteStore } from '@/plugins/pinia/routeStore.ts';
import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router';

const { t } = useI18n();

const returnRoute = ref<RouteLocationNormalizedLoadedGeneric | null>(null);

onMounted(() => {
  const routeStore = useRouteStore();
  const lastRoute = routeStore.lastRoute;
  if (lastRoute?.name === 'search') {
    returnRoute.value = lastRoute;
  } else {
    returnRoute.value = null;
  }
});
</script>

<template>
  <nav v-if="returnRoute" aria-label="Breadcrumb" class="flex">
    <ol class="flex items-center space-x-4" role="list">
      <li>
        <RouterLink :to="returnRoute" class="flex items-center text-gray-400 hover:text-gray-500">
          <FontAwesomeIcon :icon="faArrowLeft" class="mr-2" />
          <span>{{ t('views.project.breadcrumbs.return') }}</span>
        </RouterLink>
      </li>
    </ol>
  </nav>
</template>

<style lang="css" scoped></style>
